import React from 'react';
import { CheckIcon, GlobeIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { Countdown } from '../Countdown';
import { ScarcityBar } from '../ScarcityBar';
const stack = [{
  emoji: '📘',
  title: 'DVO CLINICAL WORKFLOW BUILDER™',
  detail: '6 Professional Workflow Volumes',
  value: '$147'
}, {
  emoji: '🎁',
  title: '5 PROFESSIONAL BONUSES',
  detail: 'Red Flag Workflow, Master Flow Map, Workflow Case Lab, Quick Cards and Pre-Planning Audit',
  value: '$197'
}, {
  emoji: '📋',
  title: '40+ CLINICAL WORKFLOW TOOLS',
  detail: 'Protocols, workflow maps, checklists, matrices, trackers and case-planning worksheets',
  value: '$97'
}];
const inclusions = ['Instant digital access', 'Lifetime access', 'No monthly subscription', '6 Professional Workflow Volumes', '5 Exclusive Bonuses', '40+ Clinical Workflow Tools', '7-Day Guarantee'];
export function Offer() {
  return <section id="offer" className="w-full bg-navy-900 px-4 py-16 sm:px-6 sm:py-20" data-id="element-264" data-mp="1kl89ywefpfas">
      <div className="mx-auto max-w-3xl" data-id="element-265" data-mp="1fmdfgx73u2au">
        <p className="text-center text-[11px] font-bold uppercase tracking-[0.18em] text-go" data-id="element-266" data-mp="1flc22m2m93py">
          🏆 The complete Dr. Karito workflow system
        </p>
        <h2 className="mt-3 text-center font-display text-3xl font-bold leading-tight text-white sm:text-4xl" data-id="element-267" data-mp="16lp284pjc5z0">
          Here’s everything you get today
        </h2>

        <div className="mt-9 space-y-3" data-id="element-268" data-mp="23b6ej2j0wq9o">
          {stack.map(item => <div key={item.title} className="flex items-start gap-4 rounded-2xl bg-white/[0.05] p-4 ring-1 ring-white/10 sm:p-5" data-id="element-269" data-mp="1zbnusa2xul8f">
              <span className="text-2xl" aria-hidden="true" data-id="element-270" data-mp="1pl2ywuenfut7">
                {item.emoji}
              </span>
              <div className="min-w-0 flex-1" data-id="element-271" data-mp="2n071wma94ryx">
                <h3 className="text-[13.5px] font-extrabold uppercase leading-tight tracking-[0.05em] text-white" data-id="element-272" data-mp="2n21r4csk368t">
                  {item.title}
                </h3>
                <p className="mt-1 text-[13.5px] leading-snug text-white/60" data-id="element-273" data-mp="316s9u9yj6xn9">{item.detail}</p>
              </div>
              <span className="shrink-0 self-center rounded-lg bg-white/10 px-2.5 py-1.5 text-[12px] font-extrabold text-white" data-id="element-274" data-mp="36429eifmwpot">
                {item.value}
              </span>
            </div>)}
        </div>

        <div className="mt-8 rounded-3xl bg-white p-6 shadow-lift sm:p-8" data-id="element-275" data-mp="2wco3nsx3atn8">
          <div className="flex items-baseline justify-center gap-3" data-id="element-276" data-mp="2iden2s4z1xiq">
            <span className="text-[11px] font-bold uppercase tracking-[0.16em] text-ink-muted" data-id="element-277" data-mp="2necbvnkhlpt7">
              Total value
            </span>
            <span className="font-display text-2xl font-bold text-ink-muted line-through decoration-flag decoration-2" data-id="element-278" data-mp="29g4c77w2gaec">
              $441
            </span>
          </div>

          <p className="mt-5 text-center text-[11.5px] font-bold uppercase tracking-[0.14em] text-ink-soft" data-id="element-279" data-mp="7o9btof9fsbf">
            Today you get everything for just
          </p>
          <p className="mt-1 text-center font-display text-[4.5rem] font-extrabold leading-none text-go sm:text-[5.5rem]" data-id="element-280" data-mp="1w62huic503il">
            $27
          </p>
          <p className="text-center text-[11px] font-bold uppercase tracking-[0.18em] text-ink-muted" data-id="element-281" data-mp="1s6tk72dz7lhr">
            One-time payment
          </p>

          <ul className="mx-auto mt-6 grid max-w-md gap-2 sm:grid-cols-2" data-id="element-282" data-mp="21559n133wd8m">
            {inclusions.map(inc => <li key={inc} className="flex items-start gap-2.5" data-id="element-283" data-mp="2ftiaoch1wm9z">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-go" aria-hidden="true" data-id="element-284" data-mp="2avqhlf4o6u47" />
                <span className="text-[14px] leading-snug text-ink" data-id="element-285" data-mp="2ov9bp40nc4xi">{inc}</span>
              </li>)}
          </ul>

          <div className="mt-7" data-id="element-286" data-mp="2jvwqsotc57xk">
            <CTAButton label="Get the DVO Clinical Workflow Builder™" subline="One payment of $27 · Instant access · Lifetime reference" data-id="element-287" data-mp="2jwofdfoim5ec" />
          </div>

          <div className="mt-7" data-id="element-288" data-mp="pjorz0dw86wi">
            <Countdown label="This price expires in" data-id="element-289" data-mp="pkhxjy148qd2" />
          </div>

          <div className="mt-7" data-id="element-290" data-mp="rwitb1eb1f60">
            <ScarcityBar data-id="element-291" data-mp="vydso0codih5" />
          </div>

          <p className="mx-auto mt-5 flex max-w-sm items-start justify-center gap-2 text-center text-[12.5px] leading-relaxed text-ink-soft" data-id="element-292" data-mp="vx2q23uyugrm">
            <GlobeIcon className="mt-0.5 h-4 w-4 shrink-0 text-navy-400" aria-hidden="true" data-id="element-293" data-mp="10vnt0b1lrejr" />
            <span data-id="element-294" data-mp="15uh2zthoknf6">
              <strong className="font-bold text-ink" data-id="element-295" data-mp="8930v8dayyf5">Currency is converted automatically</strong> —
              you pay the $27 equivalent in your local currency.
            </span>
          </p>
        </div>
      </div>
    </section>;
}